import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Globe, Loader2, Phone, MessageCircle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { API, SITE, errMsg } from "@/lib/api";

const empty = { name: "", email: "", subject: "", message: "" };

export default function ContactPage() {
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/contact`, f);
      toast.success("Message sent. We'll get back to you soon.");
      setF(empty);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-12">
      <div className="space-y-6">
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#FF6B00]">Contact</p>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0A192F]">Talk to our shipping desk</h1>
        <p className="text-slate-600">Questions about a consignment, a quote, or a delivery? Send us a message.</p>
        <div className="bg-[#0A192F] text-white rounded-sm p-6 space-y-4" data-testid="contact-info-card">
          <a href={SITE.tel} className="flex items-center gap-3 hover:text-[#FF6B00]" data-testid="contact-phone"><Phone className="h-5 w-5 text-[#FF6B00] shrink-0" /> Call us · Toll Free Support: {SITE.phone}</a>
          <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[#FF6B00]" data-testid="contact-whatsapp"><MessageCircle className="h-5 w-5 text-[#FF6B00] shrink-0" /> WhatsApp: {SITE.phone}</a>
          <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 hover:text-[#FF6B00] break-all" data-testid="contact-email"><Mail className="h-5 w-5 text-[#FF6B00] shrink-0" /> {SITE.email}</a>
          <p className="flex items-center gap-3" data-testid="contact-domain"><Globe className="h-5 w-5 text-[#FF6B00]" /> {SITE.domain}</p>
        </div>
      </div>
      <form onSubmit={submit} className="bg-white border border-slate-200 rounded-sm p-6 md:p-8 space-y-4" data-testid="contact-form">
        <div className="grid sm:grid-cols-2 gap-4">
          <Input required placeholder="Your name" value={f.name} onChange={set("name")} data-testid="contact-name-input" />
          <Input required type="email" placeholder="Your email" value={f.email} onChange={set("email")} data-testid="contact-email-input" />
        </div>
        <Input placeholder="Subject (e.g. tracking number)" value={f.subject} onChange={set("subject")} data-testid="contact-subject-input" />
        <Textarea required rows={6} placeholder="How can we help?" value={f.message} onChange={set("message")} data-testid="contact-message-input" />
        <Button type="submit" disabled={busy} className="bg-[#FF6B00] hover:bg-[#E05D00] h-11 px-8" data-testid="contact-submit-btn">
          {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Send message
        </Button>
      </form>
    </div>
  );
}
